var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.111 2C43.811 2 46 4.189 46 6.889V41.11c0 2.7-2.189 4.889-4.889 4.889H6.89A4.89 4.89 0 0 1 2 41.111V6.89C2 4.189 4.189 2 6.889 2zM8.742 39.889h6.56V18.703h-6.56zm23.436-21.832c-4.458 0-6.356 3.443-6.387 3.5v-2.854h-6.293V39.89h6.293V28.768c0-2.98 1.371-4.752 3.996-4.752 2.413 0 3.572 1.703 3.572 4.752v11.12h6.53V26.478c0-5.676-3.218-8.42-7.711-8.42M11.992 8.11c-2.143 0-3.88 1.75-3.88 3.909s1.737 3.91 3.88 3.91 3.88-1.752 3.88-3.91c-.001-2.159-1.737-3.908-3.88-3.909"
  })));
};
export default SvgLinkedin;